import React from "react";
import {
  Box,
  CssBaseline,
  Divider,
  Link,
  Paper,
  Typography,
  useTheme,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import UserNameInput from "./UserNameInput";

export default function SignUp() {
  const theme = useTheme();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        p: { xs: 2, sm: 3, md: 4 },
        backgroundColor: theme.palette.background.default || "#f5f6f8",
      }}
    >
      <CssBaseline />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "100%",
          maxWidth: 440,
          my: "auto",
        }}
      >
        <Box
          component="img"
          src="/logo.svg"
          alt="Technove Dokandari Logo"
          sx={{
            width: { xs: 180, sm: 220 },
            maxWidth: "70vw",
            height: "auto",
            mb: 3,
            objectFit: "contain",
          }}
        />

        <Paper
          elevation={0}
          sx={{
            width: "100%",
            p: { xs: 2.5, sm: 4 },
            borderRadius: { xs: 2.5, sm: 3 },
            border: 1,
            borderColor: "divider",
            backgroundColor: "background.paper",
            boxShadow: "0 8px 32px rgba(0, 0, 0, 0.06)",
          }}
        >
          <Typography
            variant="h4"
            component="h1"
            textAlign="center"
            fontWeight={700}
            color="text.primary"
            sx={{ fontSize: { xs: "1.35rem", sm: "1.6rem" }, mb: 0.5 }}
          >
            Create an Account
          </Typography>

          <Typography
            variant="body2"
            textAlign="center"
            color="text.secondary"
            sx={{ mb: 2 }}
          >
            Enter your details to register
          </Typography>

          <UserNameInput />

          <Divider sx={{ my: 2 }} />

          <Box sx={{ textAlign: "center" }}>
            <Typography variant="body2" color="text.secondary">
              Already have an account?{" "}
              <Link
                component={RouterLink}
                to="/signin"
                color="primary"
                fontWeight={600}
                underline="hover"
              >
                Sign In
              </Link>
            </Typography>
          </Box>
        </Paper>
      </Box>

      {/* Footer Branding */}
      <Box sx={{ mt: 4, textAlign: "center" }}>
        <Typography variant="body2" color="text.secondary">
          A solution by{" "}
          <Link
            color="primary"
            underline="hover"
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.technove.com.au/"
            fontWeight={600}
          >
            Technove
          </Link>
        </Typography>
      </Box>
    </Box>
  );
}
